// src/reducers/socketMiddleware.js

import { SET_USER } from "../actions/authTypes"
import { ADD_NOTE, DELETE_NOTE, EDIT_NOTE, GET_NOTES, VIEW_NOTE } from "../actions/noteTypes"
import { SOCKET_CONNECT, SOCKET_DISCONNECT } from "../actions/socketTypes"
import io from "socket.io-client"
import { matchFilters, sanitizeNotes } from "../utils/filters"
import { ADD_TAG, GET_TAGS } from "../actions/tagTypes"
import { log } from "../utils/logger"

let socket = null
let firstConnect = true
let socketURL = process.env.REACT_APP_RUN_DOCKER === "TRUE"
    ? process.env.REACT_APP_DOCKER_SOCKET_URL
    : process.env.REACT_APP_SOCKET_URL

const connectToCypressSocket = () => {
    const socket = {
        listeners: {},
        on(event, callback) {
            this.listeners[event] = this.listeners[event] || []
            this.listeners[event].push(callback)
        },
        emit(event, payload) {
            window.Cypress.env('emittedEvents', [
                ...(window.Cypress.env('emittedEvents') || []),
                { event, payload },
            ])
        },
        off() {},
        disconnect() {},
        connected: true,
    }
    window.__mockSocket = socket
    return socket
}

export const socketMiddleware = store => next => action => {
    switch(action.type){
        case SOCKET_CONNECT:
            if (!socket){
                if (window.Cypress){
                    socket = connectToCypressSocket()
                }
                else{
                    socket = io(socketURL,{
                        path: '/socket.io',
                        withCredentials: true,
                        reconnection: true,
                        reconnectionAttempts: Infinity,
                        reconnectionDelay: 1000,
                        reconnectionDelayMax: 30000,
                        randomizationFactor: 0.5
                    })
                }
                socket.on("connect",()=>{
                    if (firstConnect){
                        firstConnect = false
                    }
                    else{
                        socket.emit('requestData')
                    }
                })
                socket.on("disconnect",()=>{
                    log("Disconnected to socket")
                })
                socket.on("error",(err)=>{
                    log("Connection error = ",err)
                })
                socket.on("data:retrieve",(data)=>{
                    const { notes, user, tags} = data
                    const state = store.getState()
                    const { sortParams, filterParams, search } = state.noteState
                    const currentTags = state.tagState.tags
                    store.dispatch({type: GET_NOTES, payload: sanitizeNotes(notes,sortParams,filterParams,search)})
                    store.dispatch({type: SET_USER, payload: user})
                    if (currentTags) store.dispatch({type: GET_TAGS, payload: tags})
                })
                socket.on("notes:add",(note)=>{
                    const state = store.getState()
                    const { filterParams, search } = state.noteState
                    if (matchFilters(note,filterParams,search)) store.dispatch({type:ADD_NOTE,payload:note})
                })
                socket.on("notes:update",(note)=>{
                    const state = store.getState()
                    const { filterParams, search, selectedNote } = state.noteState
                    if (matchFilters(note,filterParams,search)){
                        store.dispatch({type:EDIT_NOTE,payload:note})
                    }
                    else{
                        store.dispatch({type:DELETE_NOTE,payload:note._id})
                    }
                    if (selectedNote?._id === note._id){
                        store.dispatch({type:VIEW_NOTE,payload:note})
                    }
                })
                socket.on("notes:delete",(note_id)=>{
                    store.dispatch({type:DELETE_NOTE,payload:note_id})
                })
                socket.on("user:update",(user)=>{
                    store.dispatch({type:SET_USER,payload:user})
                })
                socket.on("tags:add",(tag)=>{
                    store.dispatch({type:ADD_TAG,payload:tag})
                })
            }
            break
        case SOCKET_DISCONNECT:
            if (socket && socket?.connected) {
                socket.disconnect()
                socket = null
            }
            break
        default:
            break
    }
    return next(action)
}